import { render, staticRenderFns } from "./Organzational.vue?vue&type=template&id=6d734c4e&scoped=true"
import script from "./Organzational.vue?vue&type=script&lang=js"
export * from "./Organzational.vue?vue&type=script&lang=js"
import style0 from "./Organzational.vue?vue&type=style&index=0&id=6d734c4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d734c4e",
  null
  
)

export default component.exports